import 'slick-carousel';
import { resizeBackgroundImages } from './responsive-images';

const $sliderIntro = $('.slider-intro');
const $sliderNotices = $('.slider-notices');
const $sliderRecommended = $('.slider-recommended');
const $sliderRecent = $('.slider-recent');
const $sliderProduct = $('.slider-product');
const $sliderThumbs = $('.slider-thumbs');

if ($sliderIntro.length) {
	$sliderIntro.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		arrows: false,
		infinite: false,
		fade: true,
		cssEase: 'linear'
	});

	const sliderImages = document.querySelectorAll('.responsive-background-image');
	$sliderIntro.on('afterChange', function() {
		resizeBackgroundImages(sliderImages);
	});
}

if ($sliderNotices.length) {
	$sliderNotices.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
		arrows: true,
		infinite: false,
		fade: true,
		cssEase: 'linear',
		autoplay: true,
		autoplaySpeed: 6000
	});
}

if ($sliderRecommended.length) {
	$(window).on('load resize', function() {
		if ($(window).width() <= 1023 && !$sliderRecommended.hasClass('slick-initialized')) {
			$sliderRecommended.slick({
				slidesToShow: 2,
				slidesToScroll: 1,
				dots: false,
				arrows: true,
				infinite: false,
				responsive: [
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							dots: false,
							arrows: true,
							infinite: false
						}
					}
				]
			});
		} else if ($(window).width() > 1023 && $sliderRecommended.hasClass('slick-initialized')) {
			$sliderRecommended.slick('unslick');
		}
	});
}

if ($sliderRecent.length) {
	$(window).on('load resize', function() {
		if ($(window).width() <= 1023 && !$sliderRecent.hasClass('slick-initialized')) {
			$sliderRecent.slick({
				slidesToShow: 2,
				slidesToScroll: 1,
				dots: false,
				arrows: true,
				infinite: false,
				responsive: [
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							dots: false,
							arrows: true,
							infinite: false
						}
					}
				]
			});
		} else if ($(window).width() > 1023 && $sliderRecent.hasClass('slick-initialized')) {
			$sliderRecent.slick('unslick');
		}
	});
}

$sliderProduct.slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	dots: true,
	arrows: true,
	infinite: true,
	asNavFor: '.slider-thumbs'
});

$sliderThumbs.slick({
	slidesToShow: 4,
	slidesToScroll: 1,
	dots: false,
	arrows: false,
	infinite: true,
	vertical: true,
	verticalSwiping: true,
	asNavFor: $sliderProduct,
	focusOnSelect: true
});
